// extracted by mini-css-extract-plugin
export var boxItems = "_bl-1";
export var boxItemsLg = "_bl-2";
export var button = "_bl-7";
export var buttonLg = "_bl-8";
export var filterGroupBox = "_bl-0";
export var icon = "_bl-3";
export var iconSecondary = "_bl-6";
export var iconWrapper = "_bl-4";
export var iconWrapperLg = "_bl-5";